import React, { useState, useEffect } from 'react';
import Tree from 'react-d3-tree';
import userService from 'Services/UserService';

import { AiOutlineFullscreen, AiOutlineFullscreenExit, AiOutlineInfoCircle } from 'react-icons/ai';
const MyTreeComponent = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        userService
            .getUsersTree()
            .then(({ data }) => {
                const transformedData = transformData(data);
                setData(transformedData);
                setFilteredData(transformedData);
            })
            .catch((error) => console.error('Error fetching data: ', error));
    }, []);
    const transformData = (data) => {
        return data.map((user) => ({
            name: `${user.firstName} ${user.lastName}`,
            fonction: user.fonctionName,
            isDisabled: user.disabled,
            isActive: user.active,
            isAdmin: user.admin,
            children: user.children ? transformData(user.children) : [],
        }));
    };

    const filterTree = (node, query) => {
        if (!query) {
            return true;
        }

        const isMatch = node.name.toLowerCase().includes(query.toLowerCase());
        if (isMatch) {
            return true;
        }

        if (node.children) {
            return node.children.some((child) => filterTree(child, query));
        }

        return false;
    };

    const filterData = (data, query) => {
        if (!query) {
            return data;
        }

        return data
            .filter((node) => filterTree(node, query))
            .map((node) => ({
                ...node,
                children: node.children ? filterData(node.children, query) : [],
            }));
    };

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        setFilteredData(filterData(data, query));
    };

    return (
        <div>
            <input type="text" value={searchQuery} onChange={handleSearch} placeholder="Search..." />
            <div id="treeWrapper" style={{ width: '100%', height: '100vh' }}>
                {filteredData && filteredData.length > 0 && (
                    <Tree data={filteredData} orientation="vertical" renderCustomNodeElement={renderNode} />
                )}
            </div>
        </div>
    );
};

const renderNode = (rd3tProps) => {
    return (
        <CustomNode
            nodeData={rd3tProps.nodeDatum}
            triggerNodeToggle={rd3tProps.toggleNode}
            foreignObjectProps={{
                width: 100,
                // height: 100,
                height: 200,
                x: -50,
                // y: -25,
                y: 0,
            }}
        />
    );
};
const CustomNode = ({ nodeData = {}, triggerNodeToggle, foreignObjectProps = {} }) => {
    console.log(nodeData);
    return (
        <React.Fragment>
            <foreignObject {...foreignObjectProps}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid black',
                        borderRadius: '2pt',
                        overflow: 'hidden',
                        backgroundColor: 'rgb(248, 248, 255)',
                    }}
                >
                    <h3
                        style={{
                            fontSize: '7pt',
                            width: '100%',
                            textAlign: 'center',
                            backgroundColor: nodeData.isDisabled
                                ? '#f8c1c1'
                                : !nodeData.isActive
                                ? '#dbc2a1'
                                : nodeData.isAdmin
                                ? '#9dccff'
                                : '#eaeaf3',
                            margin: 0,
                            padding: '2pt',
                        }}
                    >
                        {nodeData.name}
                    </h3>
                    <ul
                        style={{
                            listStyleType: 'none',
                            padding: 0,
                            fontSize: '8pt',
                        }}
                    >
                        <li style={{ textAlign: 'center', fontSize: '6pt' }}>{nodeData.fonction}</li>
                    </ul>
                    <div
                        style={{
                            width: '100%',
                            height: '10pt',
                            backgroundColor: nodeData.isDisabled
                                ? '#f8c1c1'
                                : !nodeData.isActive
                                ? '#dbc2a1'
                                : nodeData.isAdmin
                                ? '#9dccff'
                                : '#eaeaf3',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <span
                            style={{
                                textAlign: 'center',
                                fontSize: '6pt',
                                border: '0.2pt solid lightgray',
                                borderRadius: '2pt',
                                backgroundColor: '#eae9e9',
                                height: '9pt',
                                width: '9pt',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0pt 2pt',
                            }}
                            onClick={triggerNodeToggle}
                        >
                            <AiOutlineInfoCircle />
                        </span>
                        {nodeData.children && (
                            <span
                                style={{
                                    textAlign: 'center',
                                    fontSize: '6pt',
                                    border: '0.2pt solid lightgray',
                                    borderRadius: '2pt',
                                    backgroundColor: '#eae9e9',
                                    height: '9pt',
                                    width: '9pt',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    margin: '0pt 2pt',
                                }}
                                onClick={triggerNodeToggle}
                            >
                                {nodeData.__rd3t.collapsed ? <AiOutlineFullscreen /> : <AiOutlineFullscreenExit />}
                            </span>
                        )}
                    </div>
                </div>
            </foreignObject>
        </React.Fragment>
    );
};

export default MyTreeComponent;
